import { observer } from "mobx-react-lite";
import { ShareSheetModalStore } from "@/components/modal/share-sheet/share-sheet-modal-store";
import { MakeCollectionPrivateShareSheetModalContent } from "@/components/modal/share-sheet/make-collection-private-share-sheet-modal-content";
import { ShareSheetModalContent } from "@/components/modal/share-sheet/share-sheet-modal-content";
import { ShareSheetInviteModalManager } from "@/components/modal/share-sheet/share-sheet-invite-modal-manager";
import { MDSModal } from "@/mds";

export interface ShareSheetModalProps {
  store: ShareSheetModalStore;
}

export const ShareSheetModal = observer<ShareSheetModalProps>(function ShareSheetModal({ store }) {
  const shouldShowShareSheet = !!store.modal?.isOpen && !store.isAwaitingFailureModal;
  return (
    <>
      <MDSModal isOpen={shouldShowShareSheet} handleClose={() => store.modal?.close()}>
        {store?.makeCollectionPrivateModal.isOpen ? (
          <MakeCollectionPrivateShareSheetModalContent store={store.makeCollectionPrivateModal} />
        ) : (
          <ShareSheetModalContent store={store} />
        )}
      </MDSModal>
      <ShareSheetInviteModalManager store={store} />
    </>
  );
});
